var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hasLabel
    ? _c(
        "div",
        { staticClass: "d-flex align-center" },
        [
          _c(
            "v-btn",
            {
              attrs: { small: "", icon: "", href: _vm.href, target: "_blank" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c("display-icon-badge-tooltip", {
                attrs: {
                  icon: _vm.generateMessage("alerts.predityVision.icon"),
                  "tooltip-text": _vm.generateMessage(
                    "alerts.predityVision.name"
                  )
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasSensors
            ? _c(
                "v-btn",
                {
                  attrs: {
                    small: "",
                    icon: "",
                    href: _vm.deviceMgtHref,
                    target: "_blank"
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _c("display-icon-badge-tooltip", {
                    attrs: {
                      icon: _vm.generateMessage("alerts.deviceManagement.icon"),
                      "tooltip-text": _vm.generateMessage(
                        "alerts.deviceManagement.name"
                      )
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "d-flex align-center" },
        [
          _c(
            "v-btn",
            {
              attrs: { small: "", text: "", href: _vm.href, target: "_blank" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c("v-icon", { attrs: { left: "" } }, [
                _vm._v(_vm._s(_vm.generateMessage("alerts.predityVision.icon")))
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.generateMessage("alerts.predityVision.name")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasSensors
            ? _c(
                "v-btn",
                {
                  attrs: {
                    small: "",
                    text: "",
                    href: _vm.deviceMgtHref,
                    target: "_blank"
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.generateMessage("alerts.deviceManagement.icon")
                        ) +
                        "\n    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.generateMessage("alerts.deviceManagement.name")
                      )
                    )
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }